var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCybersecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,16.9l-2.3-2.3l-2.8,2.8l5.1,5.1l7.1-7.1l-2.8-2.8L16,16.9z M21.1,15.5L16,20.6l-3.1-3.1l0.8-0.8l2.2,2.3 l4.3-4.3L21.1,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30,9.4c0-0.9,0-1.7,0-2.5V6.1h-0.7c-4.9,0-8.6-1.4-11.8-4.4L17,1.3l-0.5,0.4c-3.1,3-6.9,4.4-11.8,4.4H4v0.8 c0,0.8,0,1.7,0,2.5c-0.1,4.1-0.2,8.7,1.4,12.9c1.8,4.9,5.5,8.3,11.4,10.3l0.2,0.1l0.2-0.1c5.8-2,9.5-5.4,11.4-10.3 C30.2,18.1,30.1,13.5,30,9.4z M17,31.3C5.1,27,5.2,17.3,5.4,9.4c0-0.6,0-1.2,0-1.8c4.7-0.1,8.4-1.5,11.6-4.4 c3.2,2.9,6.8,4.3,11.6,4.4c0,0.6,0,1.2,0,1.8v0.1C28.8,17.3,28.9,27,17,31.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCybersecurity);
export default __webpack_public_path__ + "static/media/cybersecurity.46cf934eeb8f180f6730adbd852a466b.svg";
export { ForwardRef as ReactComponent };